import React from 'react';
import TaskList from './TaskList';
import gql from 'graphql-tag';
import { useSelector } from 'react-redux';
import { PageContainer } from '../../components/shared/Page/PageContainer';

const QUERY_USER_TASKS = gql`
  query MyUserTasks($userProfileId: ID, $limit: Int) {
    userRelatedTasks(userProfileId: $userProfileId, limit: $limit) {
      taskId
      vendorOpportunityId
      regarding
      status
      assignedToUserProfileId
      assignedToAccountId
      assignedByUserProfileId
      assignedByAccountId
      notes
      priority
      createdBy
      createdDateTime
      assignedByUser
      assignedByAccount
      assignedToUser
      assignedToAccount
      notifyByEmail
      notifyByText
      lastReminderSent
      nextReminder
      creditSubId
      taskItems {
        taskItemId
        type
        docType
        taskAssignorNotes
        taskAssigneeNotes
        doc {
          documentId
          vendorOpportunityId
          source
          docType
          docDescription
          createdBy
          docName
        }
      }
    }
  }
`;

function LenderConsolidatedTasks(props) {
  const account = useSelector(state => state.account);
  const userProfile = useSelector(state => state.userProfile);
  const relatedUsers = useSelector(state => state.relatedUsers);
  const cs = props.creditSubmission;

  return (
    <PageContainer>
      <TaskList
        cs={cs}
        account={account}
        tileTitle={'Tasks'}
        queryTasksOptions={{
          variables: { limit: 100 },
          context: { authRequired: true },
        }}
        queryTasks={QUERY_USER_TASKS}
        userProfile={userProfile}
        tasksQueryKey="userRelatedTasks"
        relatedUsers={relatedUsers}
        taskOnClickAction="openCS"
        addTaskFlag={false}
        refetchDocs={null}
      />
    </PageContainer>
  );
}

export default LenderConsolidatedTasks;
